
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import * as Font from 'expo-font';
import { Dimensions, FlatList, StyleSheet, Modal, Platform, useWindowDimensions, Alert, Image, ScrollView } from 'react-native';

//LogBox.ignoreAllLogs(); //Ignore all log notifications
//import { Authenticator, APIOverrides, ProfileManager, LinearGradient, Colors, BettorSearch, SocialComponents, MyWallet, Checkout, PollCampaign, CompetitionModule, Components, AdServer, Observer, BEEventApi, AdProvider, BracketRoom, SocketManager, SquaresModule, PromotedOrder, CompetitionManager, EngageModule, SeasonManager, SeasonModule, MarketComponents, LocationTracker, usePlayerLocation, EventComponents, Share, MarketMaker } from 'be-components';
import { APIOverrides, Observer, Campaign, BettorSearch, usePlayerLocation,Share, PollCampaign, ProfileManager,EngageModule,Checkout, MyWallet, CompetitionManager, CompetitionModule, BracketRoom, AdProvider, AdServer, SocialComponents, Components, EventComponents, SocketManager, MarketComponents, SquaresModule , Authenticator, LocationTracker, NotificationModule, MarketMaker, ManageBracketCompetitionForm, Leaderboard, LeaderboardCard, PlayerRecommender, ContactsCard, ContactsSelector, GolfScoreboard, FlashMarket, FlashHolder, BEPostHog, BetMatch, ManageFilter, RankingsCard, GroupComponent, CreateGroupWizard, CreateEngagement, AdminCompetitionList, SquaresManager, DiscordConnectionManager, ManageFlashMarket, PartnerPortal, EmbedManager, CreateEmbed, ReferralCodeManager, FlashCampaignManager, MyAction, BettorBotDashboard, NotificationManager, BetRouter, LivePriceChart, TradeChartAdapter} from 'be-components';
import type { AuthenticatedProps } from '../../src/Authenticator/api/types';
import type { ArticleProps, AthleteProps, BestAvailableOrderProps, BestAvailableResponseProps, CompetitionProps, EventOrderStatProps, EventProps, ItemOrderProps, LeagueProps, MarketProps, MatchProps, MyPlayerProps, OrderBookProps, OrderProps, ParlayPositionProps, ParlayProps, PlayerPremiumItem, PollProps, PostProps, PremiumItemProps, PublicPlayerProps, SquaresCompetitionProps, TagProps, TeamProps, TournamentProps, TradeProps } from '../../src/types';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Colors from '../../src/constants/colors';
import { Button, ConfirmationModal } from '../../src/Components';
import OrderBookChart from '../../src/MarketComponents/components/OrderBookChart';
import BestAvailableOrderCard from '../../src/MarketComponents/components/BestAvailableOrderCard';
import OrderBookCard from '../../src/MarketComponents/components/OrderBook';
import MyOrderList from '../../src/MarketComponents/components/MyOrderList';
import ExternalPriceComparison from '../../src/MarketComponents/components/ExternalPriceComparison';
import { Text, View } from '../../src/Components/Themed';
import DropDown from '../../src/Components/Dropdown';
import { FormattedText, FormattedTextInput, GroupChat, InputBar, Poster } from '../../src/SocialComponents';
import { SocialComponentApi, SocialComponentHelpers } from '../../src/SocialComponents/api';
import { ProfileApi } from '../../src/ProfileManager/api';
import { MarketComponentApi } from '../../src/MarketComponents/api';
import MarketApp from '../market/app';
import EmbedApp from '../embed/app';
import ImageUploader from '../../src/Components/ImageUploader';
//import { Spring } from '../../src/Components';
//import TournamentList from '../../src/MarketComponents/components/TournamentList';

const campaign_options = [{ campaign_id: 2, label:'North House', ad_url: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1742400602/cansgd_tzgl72.webp' },
    {campaign_id: 4, label:'Gassy', ad_url:'https://res.cloudinary.com/hoabts6mc/image/upload/v1742440890/Artboard_nbyv0d.webp'}
]


export default function App() {
  const top = Platform.OS == 'web' ? 0 : 20
  const [ loaded, setLoaded ] = useState(false);
  const [ order_book_data, setOrderBookData ] = useState<{
    order_book?:OrderBookProps,
    book_orders:OrderProps[],
    router_orders?:BestAvailableOrderProps[]
    book_market?:MarketProps
  }>({
    book_orders: [],
  });
  const [ bet_match_data, setBetMatchData ] = useState<{
    order:OrderProps
    contest_title:string
  }|undefined>(undefined);
  const [ selected_campaign, setSelectedCampaign ] = useState<any>(42)
  const { order_book, book_orders, book_market } = order_book_data;
  const [ manage_bracket, setManageBracket ] = useState<string|undefined>(undefined);
  const [ pod_ep, setPodEp ] = useState<string|undefined>(undefined);
  const [ me, setMe ] = useState<MyPlayerProps | undefined>(undefined);
  const [ me_new, setNew ] = useState<any>({})
  const [ post_data, setPostData ] = useState<{
    post_players:PublicPlayerProps[],
    post?:PostProps,
    post_orders:OrderProps[],
    post_articles:ArticleProps[]
  }>({
    post_players: [],
    post_orders: [],
    post_articles:[]
  });
  const [ golf_data, setGolfData ] = useState<{
    markets:MarketProps[]
  }>({
    markets: []
  });
  const [ trades_chart, setTradesChart ] = useState<TradeProps[]>([]);
  const { width, height } = useWindowDimensions();
  const mode = width > 600 ? 'desktop' : 'mobile'
  const { post } = post_data;
  const [ example_size, setExampleSize ] = useState({ height:0, width:0 });
  const [ competitions, setCompetitions ] = useState<CompetitionProps[]>([]);
  const [squares, setSquares] = useState<SquaresCompetitionProps[]>([]);
  const [ share_event, setShareEvent ] = useState<{
    visible:boolean,
    title:string,
    event_id?:string
  }>({
    visible: false,
    title: '',
    event_id:''
  })
  const [ input_state, setInputState ] = useState<{
    text: string,
    formatted_text: any,
    tags:TagProps[],
    init_data?: { formatted_text:string, text:string, tags:TagProps[] }
  }>({
    text: '',
    tags:[],
    formatted_text: JSON.stringify('')
  })
  const [ team_data, setTeamData ] = useState<{team?:TeamProps, athletes:AthleteProps[]}>({
      athletes: []
  }); 
  const [ tourney_data, setTourneyData ] = useState<{
    tournament?:TournamentProps,
    league?:LeagueProps,
    matches:MatchProps[]
  }>({
    matches:[],
    league:undefined
  })
  const [ parlay_data, setParlayData ] = useState<{
    parlay?:ParlayProps,
    parlay_positions:ParlayPositionProps[],
    parlay_orders:OrderProps[]
    teams:TeamProps[],
    players:PublicPlayerProps[],
    athletes:AthleteProps[],
    leagues:LeagueProps[]
  }>({
    parlay_positions: [],
    parlay_orders:[],
    players:[],
    teams:[],
    athletes:[],
    leagues:[]
  })
  const [ best_available_data, setBestAvailableData ] = useState<{
    best_available?:any,
    event?:EventProps,
    flash_markets?:PollProps[],
    match?:MatchProps,
    show_guide:boolean,
    tournament?:TournamentProps,
    parlays:ParlayProps[],
    markets:MarketProps[],
    orders:BestAvailableOrderProps[],
    latest_trades:TradeProps[],
    match_trades:TradeProps[],
    match_orders:BestAvailableOrderProps[],
    match_stats:EventOrderStatProps[],
    leagues:LeagueProps[],
    event_order_stats:EventOrderStatProps[]
  }>({
    markets:[],
    orders:[],
    leagues:[],
    match_orders:[],
    show_guide: false,
    parlays: [],
    match_trades:[],
    match_stats:[],
    latest_trades: [],
    event_order_stats:[]
  });
  const {event, tournament, best_available, flash_markets, leagues, markets, orders, match_orders, match_stats, match_trades, latest_trades, event_order_stats} = best_available_data;
  const [ active_component, setActiveComponent ] = useState<string|null>('bet_router');
  const [ component_search, setComponentSearch ] = useState('');
  const [ draft_checkout, setDraftCheckout ] = useState<{
    visible:boolean,
    item_order:ItemOrderProps,
    account_id?:string
  }>();
  const [ tourneys, setTourneys ] = useState<TournamentProps[]>([]);
  const [ search_results, setSearchResults ] = useState<{
    offset:number,
    players:PublicPlayerProps[]
  }>({
    offset: 0,
    players: []
  });
  const [ show_profile, setShowProfile ] = useState<{visible:boolean, show_welcome?:boolean}>({
    visible:false,
    show_welcome:false
  });

  const [ auth_state, setAuthState ] = useState<any>({})

  useEffect(() => {
    //APIOverrides.setEnvironment('DEVELOPMENT');
    startUp()
  },[]);


  const [font_loaded, error] = Font.useFonts({
    BarlowBold: require('../assets/fonts/Barlow-Bold.ttf'),
    BarlowSemiBold: require('../assets/fonts/Barlow-SemiBold.ttf'),
    BarlowReguar: require('../assets/fonts/Barlow-Regular.ttf'),
    BarlowLight: require('../assets/fonts/Barlow-Light.ttf'),
  });

  const startUp = async() => {
    const resp = await APIOverrides.start({
      env: 'PRODUCTION',
      no_cache: false
    });
    let me:MyPlayerProps|undefined = undefined
    let prem_items:PremiumItemProps[] = []
    let player_prem_items:PlayerPremiumItem[] = []
    let orders:OrderProps[] = []
    if(resp.authenticated){
      ProfileApi.setEnvironment();
      MarketComponentApi.setEnvironment();
      orders = await MarketComponentApi.getMyAction();
      const { player, player_premium_items } = await ProfileApi.getMyDetails();
      prem_items = await ProfileApi.getPremiumItems();
      player_prem_items = player_premium_items
      me = player
    }
    setAuthState({ ...resp, me, orders, player_premium_items:player_prem_items, premium_items:prem_items })
    setLoaded(true)
  } 

  useEffect(() => {
    if(['team_event_market', 'hot_markets','best_available_order', 'set_market'].includes(active_component)){ getMarketData('120225') }
    if(['charts'].includes(active_component)){ getTradesData('116359', '2', 0) }
    if(['parlay'].includes(active_component)){ getParlayData('57') }
    if(['golf'].includes(active_component)){ getGolfData() }
    if(['tournament_market'].includes(active_component)){ getTourneyData('951') }
    if(['tournament_list'].includes(active_component)){ getTournaments() }
    if(['order_book','bid_ask'].includes(active_component)){ getOrderBook('team','120225', '1', -29.5) }
    if(['post'].includes(active_component)){ getPostData() }
    if(active_component == 'team'){ getTeamData() }
    if(active_component == 'rich_input'){ getInputData() }
  },[active_component]);

  const getTradesData = async(event_id:string, market_id:string, var_1:number) => {
    const trd_resp = await axios.get(`https://api.markets.bettoredge.com/v1/trades/event/all/${event_id}/${'team'}?market_id=${market_id}&var_1=${var_1}`);
    const mk_resp = await axios.get(`https://api.markets.bettoredge.com/v1/markets/all`);
    const market = mk_resp.data.markets.find(m => m.market_id == market_id);

    // Create reversed trades if we only have one side
    const allTrades = market
      ? TradeChartAdapter.createReversedTrades(trd_resp.data.trades, market)
      : trd_resp.data.trades;

    setTradesChart(allTrades);
  }

  const getGolfData = async() => {
    const mk_resp = await axios.get(`https://api.markets.bettoredge.com/v1/markets/all`);
    setGolfData({
      markets: mk_resp.data.markets
    });
    getTourneyData('934')
  }

  const getParlayData = async(parlay_id:string) => {
    MarketComponentApi.setEnvironment();
    const resp = await axios.get(`http://localhost:3001/v1/parlays/parlay/${parlay_id}`);

    //Get athletes
    let athlete_ids = resp.data.orders.filter(o => o.side_type == 'athlete').map(o => o.side_id);
    let team_ids = resp.data.orders.filter(o => o.side_type == 'team').map(o => o.side_id);
    let athletes = await MarketComponentApi.getAthletesByIds(athlete_ids);
    let teams = await MarketComponentApi.getTeamsByIds(team_ids)
    let leagues = await MarketComponentApi.getLeagues();

    let player_ids = resp.data.parlay_positions.map(pp => pp.player_id);
    player_ids = player_ids.concat(resp.data.parlay.player_id);
    let players = await MarketComponentApi.getPlayersByIds(player_ids);

    setParlayData({
      parlay: resp.data.parlay,
      parlay_orders: resp.data.orders,
      parlay_positions: resp.data.parlay_positions,
      leagues,
      teams,
      players,
      athletes
    })
  }

  const getInputData = async() => {
    let input_d = await AsyncStorage.getItem('richinput');
    let input_t = await AsyncStorage.getItem('richtags');
    if(!input_d || !input_t){ return }
    let formatted_data = JSON.parse(input_d);
    let formatted_tags = JSON.parse(input_t);
    if(formatted_data && formatted_tags){
      setInputState({
          ...input_state,
          init_data: { text: formatted_data.text, formatted_text: formatted_data.formatted_text, tags: formatted_tags }
      })
    }
  }

  const getPostData = async() => {
    const p_res = await axios.get(`https://api.social.bettoredge.com/v1/posts/post/${'1498207'}`)
    const p = p_res.data.post
    SocialComponentApi.setEnvironment();
    let post_data = await SocialComponentHelpers.getPostsData([p]);
    setPostData({
      post: p_res.data.post,
      post_players:post_data.players,
      post_orders:post_data.orders,
      post_articles: post_data.articles
    })
  }
  const getOrderBook = async(event_type:string, event_id:string, market_id:string, var_1:number, side_id?:string) => {
    console.log('tyring')
    try {
      const resp = await axios.get(`https://api.markets.bettoredge.com/v1/orders/book?event_id=${event_id}&event_type=${event_type}&market_id=${market_id}&offset=0&var_1=${var_1}&side_id=${side_id}`);
      const mk_resp = await axios.get(`https://api.markets.bettoredge.com/v1/markets/all`);
      console.log(resp.data)
      //Lets get the routerorders to test
      const ro_resp = await axios.get(`https://betrouter.bettoredge.com/liquidity/fill/pg-1760924231342-ticy0ly-1?filler_partner_ids=pg-1760924231344-hdj7805-2`);
      let ro_data:BestAvailableResponseProps = ro_resp.data.result
      let router_orders:BestAvailableOrderProps[] = []
      ro_data.events.map(e => {
        if(!e.supported_markets){ return }
        e.supported_markets.map(sm => {
          console.log(sm)
          if(!sm.available_orders){ return }
          sm.available_orders.map(o => {
            if(!o.router_data){ return }
            router_orders.push(o);
          })
        })
      })

      setOrderBookData({
        ...order_book_data,
        order_book: resp.data.order_book,
        router_orders:router_orders,
        book_orders:resp.data.orders,
        book_market: mk_resp.data.markets.find(m => m.market_id == market_id)
      })
    } catch (e) {
        console.log(e.message)
    }
    
  }

  const getTournaments = async() => {
    const resp = await axios.get(`https://api.events.bettoredge.com/v1/tournaments/league/10`);
    setTourneys(resp.data.tournaments.filter(t => t.status == 'scheduled'))
  }

  const getTeamData = async() => {
    const resp = await axios.get(`https://api.events.bettoredge.com/v1/teams/team/${28}`)
    setTeamData({ team: resp.data.team, athletes: resp.data.athletes });
  }


  const getTourneyData = async(tournament_id:string) => {
      let bs_resp = await axios.get(`https://api.markets.bettoredge.com/v1/orders/available`);
      const mk_resp = await axios.get(`https://api.markets.bettoredge.com/v1/markets/all`);
      const leag = await axios.get(`https://be-sr-svc.herokuapp.com/v1/leagues`);
      const flash_resp = await axios.get(`https://be-auth-svc.herokuapp.com/v2/pm/active`);
      let a_orders:any[] = []
      let l_trades:any[] = []
      let e_stats:EventOrderStatProps[] = []
      let m_orders:any[] = []
      let m_trades:any[] = []
      let m_stats:EventOrderStatProps[] = []
      let tourney = bs_resp.data.tournaments.find(t => t.tournament_id == tournament_id);
      if(!tourney){
          const res = await axios.get(`https://api.events.bettoredge.com/v1/tournaments/tournament/${tournament_id}`) 
          tourney = res.data.tournament
          const resp = await axios.post(`https://api.markets.bettoredge.com/v1/trades/event/latest/bulk/get`, { event_ids:[tournament_id], event_type:'tournament' });
          l_trades = resp.data.trades
      }
      tourney.supported_markets.map(sm => {
        if(sm.available_orders){a_orders = a_orders.concat(sm.available_orders); }
        if(sm.latest_trades){ l_trades = l_trades.concat(sm.latest_trades); }
        if(sm.order_stats){ e_stats = e_stats.concat(sm.order_stats) }
      })
      //Now we need to add any match data that is available
      bs_resp.data.matches.map(m => {
        if(m.tournament_id != tourney.tournament_id){ return }
         m.supported_markets.map(sm => {
          if(sm.available_orders){m_orders = m_orders.concat(sm.available_orders); }
          if(sm.latest_trades){ m_trades = m_trades.concat(sm.latest_trades); }
          if(sm.order_stats){ m_stats = m_stats.concat(sm.order_stats) }
         })
      })
      setBestAvailableData({
        ...best_available_data,
        best_available: bs_resp.data,
        tournament: tourney,
        orders: a_orders,
        leagues: leag.data.leagues,
        flash_markets: flash_resp.data.polls,
        match_orders: m_orders,
        match_stats: m_stats,
        match_trades: m_trades,
        event_order_stats: e_stats,
        latest_trades: l_trades,
        markets:mk_resp.data.markets,
      });

  }

  const people = Object.keys(me_new)
  let family: { name:string, image:any }[] = []
  people.map(p => {
    let fam = me_new[p]
    if(fam){ family.push({ name: p, image: fam }) }
  })

  console.log(family)

  const getMarketData = async(event_id:string) => {
    let bs_resp = await axios.get(`https://api.markets.bettoredge.com/v1/orders/available`);
    const mk_resp = await axios.get(`https://api.markets.bettoredge.com/v1/markets/all`);
    const p_resp = await axios.get(`https://api.markets.bettoredge.com/v1/parlays/active`);
    const c_resp = await axios.get(`https://be-tp-svc.herokuapp.com/v2/competitions/public`);
    const s_resp = await axios.get(`https://be-tp-svc.herokuapp.com/v1/squares/public`)
    const leag = await axios.get(`https://be-sr-svc.herokuapp.com/v1/leagues`);
    const flash_resp = await axios.get(`https://be-auth-svc.herokuapp.com/v2/pm/active`);
    setCompetitions(c_resp.data.competitions);
    setSquares(s_resp.data.squares_competitions);
    let a_orders:any[] = []
    let l_trades:any[] = []
    let e_stats:EventOrderStatProps[] = []
    let nfl_event = bs_resp.data.events.find(e => e.event_id == event_id)
    if(!nfl_event){ 
      const res = await axios.get(`https://api.events.bettoredge.com/v1/events/event/${event_id}`) 
      nfl_event = res.data.event
      const resp = await axios.post(`https://api.markets.bettoredge.com/v1/trades/event/latest/bulk/get`, { event_ids:[event_id], event_type:'team' });
      l_trades = resp.data.trades
    }
    if(!nfl_event){ return }
    nfl_event.supported_markets.map(sm => {
      if(sm.available_orders){a_orders = a_orders.concat(sm.available_orders); }
      if(sm.latest_trades){ l_trades = l_trades.concat(sm.latest_trades); }
      if(sm.order_stats){ e_stats = e_stats.concat(sm.order_stats) }
    })

    
    setBestAvailableData({
      ...best_available_data,
      best_available: bs_resp.data,
      event: nfl_event,
      orders: a_orders,
      parlays: p_resp.data.parlays,
      flash_markets:flash_resp.data.polls,
      leagues: leag.data.leagues,
      event_order_stats: e_stats,
      latest_trades: l_trades,
      markets:mk_resp.data.markets,
    });
  }

  const handleLogout = () => {
    APIOverrides.clearTokens();
    APIOverrides.setBearerToken(undefined);
    setAuthState({
      ...auth_state, authenticated: false, access_token: undefined, refresh_token:undefined
    })
  }

  const handleAuthenticated = (auth:AuthenticatedProps) => {
    setAuthState({
      ...auth_state,
      authenticated:true,
      ...auth
    })
    APIOverrides.cacheTokens(auth.access_token, auth.player_id, auth.refresh_token, auth.expire_datetime);
    APIOverrides.setBearerToken(auth.access_token)
    if(auth.new_player){
      setShowProfile({
        visible: true,
        show_welcome:true
      })
    }
  }

  const available_components = [
    'authenticator', 'embed', 'bracket', 'market_manager', 'leaderboard', 'bettorbot',
    'flash_campaign_manager', 'manage_referral', 'bet_router', 'partner_portal', 'parlay',
    'group', 'new', 'create_group', 'bet_match', 'manage_filter', 'my_action',
    'leaderboard_card', 'poster', 'player_recommender', 'golf', 'contacts_selector',
    'chat', 'create_embed', 'create_engagement', 'manage_flash', 'rich_input',
    'confirmation', 'flash_holder', 'flash', 'campaign', 'manage_bracket', 'activity',
    'post', 'discord', 'tournament_list', 'my_orders', 'bid_ask', 'order_book',
    'best_available_order', 'promoted_order', 'rankings', 'tournament_market', 'ad',
    'team_profile', 'market_maker', 'squares', 'profile', 'company_profile', 'podcast',
    'notification', 'notification_manager', 'team_event_market', 'market', 'search',
    'social_profile', 'manage_embed', 'external_price', 'wallet', 'admin_engagements',
    'poll', 'set_market', 'competition', 'squares_manager', 'competition_manager',
    'season_manager', 'season', 'engage', 'location', 'charts'
  ];

  const renderComponents = (data:{item:string, index:number}) => {
    return (
      <Button
        title={data.item}
        onPress={() => setActiveComponent(data.item)}
        style={{ margin: 5 }}
      />
    )
  }
  console.log(auth_state.me)



  const client = BEPostHog.generateClient();
  const { location, getLocation, permission, checkPermissions, getPermissions } = usePlayerLocation({ player_id: auth_state.player_id, distinct_id: auth_state.distinct_id })
  if(!loaded || !font_loaded){ return <></> }
  const renderFam = (data:{ item:any, index: number }) => {
    return (
      <View style={{ flexDirection:'row'}}>
        <ImageUploader public_id={`${Math.random()}_image`} onFinishUpload={(obj) => setNew({ ...me_new, ['harper']:{ ...obj, url: obj.secure_url } })}>
                <Image
                  style={{ height:75, width:75 }}
                  resizeMode='cover'
                  source={{ uri: data.item.image.url }}
                  />
                  <Text >Change</Text>
              </ImageUploader>
              <View transparent style={{ flex:1 }}>
                <Text theme='h1' size={40}>{data.item.name}</Text>
              </View>
      </View>
    )
  }
  
  return (
    <View style={{ flex:1, height }}>
      <Observer
        distinct_id={auth_state.distinct_id}
        session_id={auth_state.session_id}
        source={Platform.OS}
      />
      {!active_component ? (
        <View style={{ flex: 1, paddingTop: Platform.OS === 'web' ? 20 : 60 }}>
          <View type='header' style={{ padding: 15 }}>
            <Text theme='h1' size={24}>Available Components</Text>
            <Text theme='description' size={14} style={{ marginTop: 5 }}>
              Select a component to view
            </Text>
          </View>
          <View transparent style={{ padding: 15, paddingTop: 10 }}>
            <Components.SearchBox
              onChange={(text) => setComponentSearch(text)}
              placeholder="Search components..."
              hide_search_button
            />
          </View>
          <FlatList
            data={available_components.filter(comp =>
              comp.toLowerCase().includes(component_search.toLowerCase())
            )}
            renderItem={renderComponents}
            numColumns={2}
            contentContainerStyle={{ padding: 10 }}
          />
        </View>
      ) : (
        <View style={{ flex:1 }}>
          {/* Back Button */}
          <View type='header' style={{
            flexDirection: 'row',
            alignItems: 'center',
            padding: 10,
            paddingTop: Platform.OS === 'web' ? 10 : 50
          }}>
            <Button
              title="← Back"
              onPress={() => setActiveComponent(null)}
              style={{ marginRight: 10 }}
            />
            <Text theme='h2' size={16}>{active_component}</Text>
          </View>

        {active_component == 'authenticator' ?
          
          <View style={{ flex:1, justifyContent:'flex-end' }}>
              <Authenticator
                  theme="full"
                  company_id='1'
                  visible={true}
                  show_referral
                  referral_code='jbone'
                  onAuthenticated={(auth_response) => {
                      handleAuthenticated(auth_response)
                  }}
                  auth_strategy_id="3"
                  source="app"
                  onClose={() => console.log('close')}
              />
          </View>
          :active_component == 'embed' ?
          <View style={{ flex:1 }}>
            <EmbedApp
              identifier='18827432-2d15-4f49-9301-790ebe7f0d77'
            />
          </View>
          :active_component == 'bracket'?
          <View style={{ flex:1, paddingTop:35, paddingBottom:30}}>
            <BracketRoom
              bracket_competition_id='740'
              view_mode={width > 600 ? 'desktop' : 'mobile'}
              player_id={auth_state.player_id}
              width={width}
              onCreateNewCompetition={(bracket_id) => {
                
              }}
              onNotEnoughBalance={(data) => console.log('DO SOMETHING!')}
              onClose={() => console.log('close this')}
              onShareCompetition={(bc) => console.log(bc)}
              onManageCompetition={(bc_id) => setManageBracket(bc_id)}
              onRequestAuthenticate={(auth_strategy_id) => Alert.alert(`AUTHENTICATE!!!, ${auth_strategy_id}`)}
            />
            {manage_bracket ?
            <View style={{ position:'absolute', top:0, left:0, right:0, bottom:0, padding:10 }}>
              <ManageBracketCompetitionForm
                bracket_competition_id={manage_bracket}
                onClose={() => setManageBracket(undefined)}
                onFail={() => console.log('FIALEd')}
                player_id={auth_state.player_id}
              />
            </View>
            :<></>}
          </View>
          :active_component == 'market_manager'?
          <View style={{ flex:1, paddingTop:50, paddingBottom:50 }}>
            <MarketComponents.MarketManager
              player_id={auth_state.player_id}
              contest_id='905'
              contest_type='tournament'
              onClose={() => console.log('')}
            />
          </View>
          :active_component == 'leaderboard' ?
          <View style={{flex:1, paddingTop:45}}>
            <Leaderboard
              player_id={auth_state.player_id}
              
            />

          </View>
          :active_component=='bettorbot' && auth_state.me ?
          <View style={{ flex:1, margin:10, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom: Platform.OS == 'web' ? 0 : 40  }}>
            <BettorBotDashboard
              me={auth_state.me}
            />
          </View>
          :active_component == 'flash_campaign_manager' && auth_state.me?
            <View style={{ flex:1, margin:10, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom: Platform.OS == 'web' ? 0 : 40  }}>
            <FlashCampaignManager
              poll_campaign_id='966'
              company_id='1'
              me={auth_state.me}
            />
          </View>
          :active_component == 'manage_referral' ?
          <View style={{ flex:1, margin:10, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom: Platform.OS == 'web' ? 0 : 40  }}>
            <ReferralCodeManager 
              float
              onClose={() => console.log('')}
              company_id={'1'}
              //player_referral_id={'10084'}

            />
          </View>
          :active_component == 'bet_router' ?
          <View style={{ flex:1,  paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom: Platform.OS == 'web' ? 0 : 40 }}>
            <BetRouter
              me={auth_state.me}
              onRequestAuthenticate={() => setActiveComponent(null)}
              insets={{ top:40, bottom:40, right:0, left:0 }}
            />
          </View>
          :active_component == 'partner_portal' && auth_state.me ?
          <View style={{ flex:1, margin:10, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom: Platform.OS == 'web' ? 0 : 40 }}>
            <PartnerPortal
              me={auth_state.me}
              company_id='1'
            />
          </View>
          :active_component == 'parlay' && parlay_data.parlay ?
          <View style={{ margin:10, borderRadius:8 }}>
            <MarketComponents.ParlayCard
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius:8, borderBottomLeftRadius: 8 }}
              parlay={parlay_data.parlay}
              orders={parlay_data.parlay_orders}
              teams={parlay_data.teams}
              athletes={parlay_data.athletes}
              leagues={parlay_data.leagues}
              players={parlay_data.players}
              parlay_positions={parlay_data.parlay_positions}
            />
          </View>
          :active_component == 'group' ?
          <View style={{ flex:1 }}>
            <GroupComponent
              group_id={'91'}
              init_invite_code='hey there'
              onSelectCompetition={() => console.log('got comp!')}
              onSelectChat={() => console.log('caht now!!')}
              onSelectPlayer={() => console.log('hey')}
              onInvitePlayer={() => console.log('hey!!!')}
              mode={mode}
              onShareGroup={() => console.log('')}
              player={auth_state.me}
            />
          </View>
          :active_component == 'new'?
          <ScrollView style={{ paddingTop:50 }}>
              <FlatList
                data={family}
                renderItem={renderFam}
                
              />
            
          </ScrollView>
          :active_component == 'create_group' && auth_state.me?
          <View style={{ flex:1 }}>
            <CreateGroupWizard
              player={auth_state.me}
            />
          </View>
          :active_component == 'bet_match' ?
          <View style={{ flex:1, paddingTop:40, paddingBottom:40 }}>
            <BetMatch
              style={{flex:1}}
              mode={mode}
              insets={{ bottom: Platform.OS == 'web' ? 0: 20, top: Platform.OS == 'web' ? 0: 35, left:0, right:0 }}
              onViewPremium={() => console.log('go to premium')}
              player_filter_id='12171'
              player_premium_items={auth_state.player_premium_items}
              premium_items={auth_state.premium_items}
              me={auth_state.me}
            />

          </View>
          :active_component == 'manage_filter' && auth_state.me ?
          <View style={{ flex:1, paddingTop:40, paddingBottom:40 }}>
            <ManageFilter
              me={auth_state.me}
              premium_items={auth_state.premium_items}
              player_premium_items={auth_state.player_premium_items}
              player_filter_id='11992'
            />

          </View>
          :active_component == 'my_action' && auth_state.me ?
          <View style={{ flex:1, paddingTop:Platform.OS == 'web'?0:40, paddingBottom:Platform.OS == 'web'?0:40 }}>
            <MyAction
              me={auth_state.me}
              market_type='FOR_MONEY'
            />
          </View>
          :active_component == 'leaderboard_card' ?
          <View style={{flex:1, paddingTop:45}}>
            <LeaderboardCard
              player_id={auth_state.player_id}
              category_id='2'
              timerange_id='1'
              onSelectPlayer={(l, p) => console.log('')}
              onSeeFull={() => console.log('')}
            />
          </View>
          :active_component == 'poster' ?
          <View style={{ flex:1 }}>
            <Poster
              insets={{ top:45, bottom:45, left:0, right:0 }}
              width={width}
              post_id={'1514576'}
              onCreatePost={(post) => alert('oost created!!!')}
            />
          </View>
          :active_component == 'player_recommender' ?
          <View style={{ flex:1, paddingTop:45 }}>
              <PlayerRecommender
                player_id={auth_state.player_id}
                region='Minnesota'
                referrer_id='100'
              />
            <ContactsCard
              player_id={auth_state.player_id}
              onFullSearch={() => console.log('')}
              onSelectContact={(pc, p) => console.log(pc)}
            />

          </View>
          :active_component == 'golf' ?
          <View style={{ flex:1, paddingTop:45, paddingBottom:45 }}>
            <BEPostHog.BEPostHogProvider client={client}>
              <GolfScoreboard
                  tournament_id='951'
                  my_orders={[]}
                  player_id={auth_state.player_id}
                  markets={golf_data.markets}
                  onOrder={(o) => console.log(o)}
                  best_available={best_available_data.orders}
                />
            </BEPostHog.BEPostHogProvider>
          </View>
          :active_component == 'contacts_selector' ?
          <View style={{ flex:1, paddingTop:45 }}>
            <ContactsSelector
              player_id={auth_state.player_id}
              onSelectContact={(pc, p) => console.log(pc)}
            />
          </View>
          :active_component == 'chat' ?
          <View style={{ flex:1, paddingBottom:280}}>
            <GroupChat
              group_id={'159401'}
              //player_id={'345'}
              onClose={() => console.log('')}
              insets={{ top:45, bottom:45, left:0, right:0 }}
              my_id={auth_state.player_id}
              onSelectImage={(image) => console.log(image)}
              onSelectTag={(tag) => console.log(tag)}
              //player_id={'345'}
              distinct_id={auth_state.distinct_id}
              access_token={auth_state.access_token}
            />
          </View>
          :active_component == 'create_embed' && auth_state?.me ?
           <View style={{ flex:1, padding:15 }}>
            <CreateEmbed
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius: 8, borderBottomLeftRadius: 8 }}
              me={auth_state.me}
              company_id={'1'}
              onClose={() => console.log('')}
              onCreateEmbed={(ce) => console.log(ce)}
            />
          </View>
          :active_component == 'create_engagement'?
          <View style={{ flex:1, padding:15 }}>
            <CreateEngagement
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius: 8, borderBottomLeftRadius: 8 }}
              player={auth_state.me}
              //group_id='91'
              init_engagement='bracket'
              company_id={'54'}
            />
          </View>
          :active_component == 'manage_flash'?
          <View style={{ flex:1, paddingTop:40, paddingBottom:40 }}>
            <ManageFlashMarket
              poll_id='5489'
              player={auth_state.me}
              onClose={() => console.log('hey')}
            />
          </View>
          :active_component == 'rich_input'?
          <View style={{ flex:1, paddingTop:75 }}>
            <View float type='header' style={{ margin:10, padding:10 }}>
              <FormattedText
                tags={input_state.text ? input_state.tags : input_state.init_data?.tags ? input_state.init_data?.tags : []}
                text={input_state.text ? input_state.formatted_text : input_state.init_data?.formatted_text ? input_state.init_data?.formatted_text : input_state.formatted_text}
                onSelectTag={(tag) => console.log(tag)}
              />
            </View>
            <View style={{ marginTop:25, padding:10 }}>
              <Text style={{ marginBottom:15 }}>INPUT RICH TEXT HERE NOW!!!</Text>
              <View type='header' style={{  }}>
                
                <InputBar 
                  width={width}
                  actions={['image']}
                  onImageUpload={(image) => console.log(image)}
                />

              </View>
              <View style={{ padding:10 }}>
              <FormattedTextInput
                init_data={input_state.init_data}
                placeholder='START TYPING YO!'
                icon_submit
                onSelectInput={() => console.log('hey')}
                submit_placement='inline'
                onFocusPosition={(position) => console.log(position)}
                onSubmit={async(data, tags) => {
                  setInputState({
                    text: data.text,
                    formatted_text: data.formatted_text,
                    tags: tags
                  })
                  await AsyncStorage.setItem(`richinput`, JSON.stringify(data))
                  await AsyncStorage.setItem(`richtags`, JSON.stringify(tags))
                }}
                onChangeText={(data) => setInputState({ ...input_state, ...data })}
              />
              </View>

            </View>
          </View>
          :active_component == 'confirmation' ?
          <View>
            <ConfirmationModal
              title='This is the title'
              visible={true}
              mode='mobile'
              description='This is the description'
              onConfirm={() => console.log('Confirmed!!!')}
              onCancel={() => console.log('CANCELLED!')}
              opt_in_url='https://www.bettoredge.com'
            />
        </View>
        :active_component == 'flash_holder'?
        <View style={{ paddingTop:40, height:500 }}>
          <View transparent style={{  flex:1 }}>
            <FlashHolder
              style={{ borderRadius:0 }}
              float
              onManageFlash={(poll) => console.log(poll)}
              //contest_type='tournament'
              //contest_id='1266'
              //compact
              player={auth_state.me}
              player_id={auth_state.player_id}
            />
          </View>
        </View>
        :active_component == 'flash' ?
        <View style={{ paddingTop:40 }}>
          <View float style={{ margin:10 }}>
          <FlashMarket
            player={auth_state.me}
            init_expanded
            onRequestAuthenticate={() => console.log('')}
            player_id={auth_state.player_id}
          />
          </View>

        </View>
          : active_component == 'campaign' ?
          <View style={{ flex:1, paddingTop:Platform.OS == 'web'?0:40, paddingBottom:Platform.OS == 'web'?0:40 }}>
            {selected_campaign ?
            <Campaign
                player_id={auth_state.player_id}
                distinct_id={auth_state.distinct_id}
                mode='golf'
                campaign_id={selected_campaign}
                onCreateOrder={(order) => console.log(order)}
                onCheckIn={() => console.log('CHECKED IN!!')}
                
            />
            :
            <View style={{ padding:20 }}>
                <Text>SELECT EVENT</Text>
                <DropDown
                    selected_value={selected_campaign?.label}
                    dropdown_options={[
                        { value: 'campaign', eligible_options: campaign_options.map(o => o.label) }
                    ]}
                    onOptionSelect={(otion) => {
                        let found_opt = campaign_options.find(o => o.label == otion)
                        setSelectedCampaign(found_opt)
                    }}
                />
            </View>
            }
        </View>
          : active_component == 'manage_bracket' ?
          <View style={{ flex:1, paddingTop:40, paddingBottom:40 }}>
            <ManageBracketCompetitionForm
              bracket_competition_id='1433'
              player_id={auth_state.player_id}
              onFail={() => console.log('')}
              onClose={() => console.log('')}
              
            />
          </View>
          :active_component == 'activity' ?
          <View style={{ flex:1 }}>
            <SocialComponents.ActivityDetail
              post_id='1689890'
              me={auth_state.me}
            />
          </View>
          : active_component == 'post' && post ?
          <View style={{ padding:10, marginTop:40 }}>
            <SocialComponents.PostCard
              post={post}
              width={width - 20 }
              onSelectPlayer={() => console.log('')}
              onRequestAuthenticate={() => console.log('atuh')}
              articles={post_data.post_articles}
              player_id={auth_state.player_id}
              player={post_data.post_players[0]}
              onSelectTag={(tag) => console.log(tag)}
              orders={post_data.post_orders}
              onCopyOrder={(o) => console.log(o)}
              onFadeOrder={(o) => console.log(o)}
              

            />
          </View>
          :active_component == 'discord' ?
          <View style={{ flex:1, paddingTop:50, paddingBottom:50 }}>
            <DiscordConnectionManager 
              player_id={auth_state.player_id}
              onRequestAuthenticate={() => console.log('')}
            />
          </View>
          :active_component == 'tournament_list' ?
          <View>
            <TournamentList
              tournaments={tourneys}
              hide_match_liquidity
              hide_participant_liquidity
            />
          </View>
          :active_component == 'my_orders' && auth_state.player_id ?
          <View>
            <MyOrderList
              market_type='FOR_MONEY'
              distinct_id={auth_state.distinct_id}
              access_token={auth_state.access_token}
              player_id={auth_state.player_id}
            />
          </View>
          :active_component == 'bid_ask' && order_book && book_market ?
          <View style={{ padding:20, paddingTop:50 }}>
            <OrderBookChart
              order_book={order_book}
              market={book_market}
              router_orders={order_book_data.router_orders}
              onSelectVar1={() => console.log('hey')}
              active_var_1={-13.5}
              market_type='FOR_MONEY'
            />

          </View>
          :active_component == 'order_book' && order_book && book_market ?
          <View style={{ padding:20, paddingTop:50 }}>
            <OrderBookCard
              orders={book_orders}
              var_1={-29.5}
              market={book_market}
              contest_id={order_book.event_id}
              contest_type={order_book.event_type}
              router_orders={order_book_data.router_orders}
              show_orders
              show_grades
              onBuy={(order) => console.log('BUY THIS SHIOT!!')}
            />

          </View>
          :active_component == 'best_available_order' && orders[0] ?
          <View style={{ backgroundColor:Colors.brand.midnight, padding:20, paddingTop:100 }}>
            <BestAvailableOrderCard
              player_id={auth_state.player_id}
              order={orders[0]}
              float
              show_grade
              style={{ borderRadius:8 }}
              onShareOrder={() => console.log()}
              
            />
          </View>
          :active_component == 'promoted_order' && best_available ?
          <View>
            <PromotedOrder
              order={best_available.events[0]?.supported_markets[0]?.available_orders[0]}
              event={best_available.events[0]}
              onBuyOrder={(o) => console.log(o)}
              onRejectOrder={(o) => console.log(o)}
              onShareOrder={() => console.log('share')}
              onViewMarket={(o) => console.log(o)}
            />
          </View>
          :active_component == 'rankings' ?
          <View>
            <RankingsCard
              league_id='2'
              team_id='319'
            />
          </View>
          :active_component == 'tournament_market' && tournament?
          <View transparent style={{ margin:5, height:2500 }}>
            <MarketComponents.TournamentMarket
                tournament={tournament}
                league={leagues.find(l => l.league_id == tournament.league_id)}
                markets={markets}
                onActivate={() => console.log('active')}
                style={{ borderRadius:8 }}
                onViewMarketStats={() => console.log('')}
                width={375}
                
                flash_markets={flash_markets}
                float={true}
                onFlashSelect={(poll_id) => console.log(poll_id)}
                //market_selector_location={'top_right'}
                //hide_liquidity
                //wrap_markets={true}
                match_available_orders={match_orders}
                match_latest_trades={match_trades}
                match_order_stats={match_stats}
                onOrder={(o) => console.log(o)}
                best_available_orders={orders}
                event_order_stats={event_order_stats}
                latest_trades={latest_trades}
            />
          </View>
          :active_component == 'ad'?
          <View style={{ height:2000 }}>
            <AdProvider distinct_id={auth_state.distinct_id} session_id={auth_state.session_id}>
              <AdServer
                placement='discover_feed'
                ad_type='discover'
                device_width={300}
                onViewAd={(evt) => {
                  console.log('IVEWEED')
                    BEEventApi.saveEvent(evt)
                }}
                onClickAd={(evt) => {
                  BEEventApi.saveEvent(evt)
                }}
              />
              <View style={{ height:2000 }}/>
              <AdServer
                placement='social_feed'
                ad_type='discover'
                device_width={300}
                onViewAd={(evt) => {
                  console.log('IVEWEED')
                    BEEventApi.saveEvent(evt)
                }}
                onClickAd={(evt) => {
                  BEEventApi.saveEvent(evt)
                }}
              />
            </AdProvider>
          </View>
          :active_component == 'team_profile' ?
          <View>
            <EventComponents.TeamProfile
              team_id='28'
              height={844}
            />
          </View>
          :active_component == 'market_maker'?
          <View style={{ height: 896 }}>
            <MarketMaker
              player_id={auth_state.player_id}
              access_token={auth_state.access_token}
              distinct_id={auth_state.distinct_id}
            />
          </View>
          :active_component == 'squares' ?
          <View style={{ height:800 }}>
            <SquaresModule
              view_mode='mobile'
              player_id={auth_state.player_id}
              sq_comp_id='2014'
              onRequestAuthenticate={() => setActiveComponent('authenticate')}
            />
          </View>
          :active_component == 'profile'?
          <Modal 
          visible={auth_state.show_authenticate}
          style={styles.modalContainer}
          animationType="slide" 
          transparent
          //presentationStyle=''
      > 
        <View type="blur" style={mode=='desktop' ? styles.desktopContainer : { ...styles.viewContainer}}>
            <View style={mode=='desktop' ?{ width:500, height:750, borderRadius:22 }:{ flex:1 }}>            
              <ProfileManager
              onRedeemCode={() => console.log('done')}
              //hidden_groups={['preferences']}
              show_welcome={true}
              float
              player={me}
              //keyboard_height={330}
              hide_powered_by
              //show_welcome={true}
              view_mode='mobile'
              insets={{top:45, bottom:300, left:0, right:0}}
              //walkthrough={{ level: 'basic' }}
              //profile_attribute='vouch'
              //hidden_levels={['verify']}
              //hidden_steps={['basic_review']}
              onClose={() => setShowProfile({ visible: false })}
              onLogout={() => handleLogout()}
            />
            </View>
            <SocketManager
            distinct_id={auth_state.distinct_id}
            access_token={auth_state.access_token}
            group_id='84'
            onConnect={() => console.log('connected!!!')}
            onDisconnect={() => console.log('disconnected!')}
            onSocketEvent={(ev) => {
              switch(ev.type){
                case 'V1_UPDATE_ME':
                  console.log('UPDATE ME!!!');
                  return setMe(ev.data);
                default: return
              }
            }}
            subscribed_events={['V1_UPDATE_ME']}
          />          
          </View>
          </Modal>
          :active_component == 'chat' ?
          <View style={{ padding:75, backgroundColor:Colors.brand.midnight }}>
            <Text color={Colors.shades.white}>CHATTING!!!!!</Text>
            <SocketManager
            distinct_id={auth_state.distinct_id}
            access_token={auth_state.access_token}
            group_id='84'
            onConnect={() => console.log('connected!!!')}
            onDisconnect={() => console.log('disconnected!')}
            onSocketEvent={(ev) => console.log(ev)}
            subscribed_events={['V1_UPDATE_GROUP_MESSAGE']}
          />
          </View>
          :active_component == 'company_profile' ?
          <View style={{ height:896, backgroundColor:Colors.shades.white }}>
            <SocialComponents.CompanyProfile
              company_id='1'
            />
          </View>
          :active_component == 'podcast' ?
          <View style={{ height:896, backgroundColor:Colors.shades.white }}>
            <SocialComponents.PodcastModule
              podcast_id='20'
              player_id={auth_state.player_id}
              onShareEpisode={(pe) => console.log(pe)}
              onSharePodcast={(p) => console.log(p)}
              onBack={() => console.log('')}
              onSelectEpisode={(ep) => setPodEp(ep.podcast_episode_id)}
            />
            {pod_ep ?
            <View transparent style={{ position:'absolute', bottom:0, left:0, right:0, padding:10 }}>
              <SocialComponents.AudioPlayer
                podcast_episode_id={pod_ep}
                player_id={auth_state.player_id}
              />
            </View>

            :<></>}
          </View>
          :active_component == 'podcast_play'?
          <View>
            
          </View>
          :active_component == 'notification' ?
          <View style={{ marginTop:75 }}>
            <NotificationModule
            />
          </View>
          :active_component == 'notification_manager' && auth_state.me ?
          <View style={{ flex:1, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom:Platform.OS == 'web' ? 0 : 40 }}>
            <NotificationManager
              player_ids={[]}
              me={auth_state.me}
              notification_type="order_notifications"
              default_path_name="/markets/market/[contest_id]"
              default_params={{ contest_id: '116757', contest_type: 'team', market_id: '1' }}
              onComplete={(notification) => console.log('Notification sent:', notification)}
              onClose={() => console.log('Close notification manager')}
            />
          </View>
          :active_component == 'team_event_market' && event ?
          <View style={{ padding:10 }}>
            <Button
              title='SHOW GUIDE'
              onPress={() => setBestAvailableData({ ...best_available_data, show_guide: true })}
            />
            <View style={{ height:234 }} />
            <MarketComponents.TeamEventMarket 
                default_price_view='best_available'
                event={event}
                float
                show_help
                highlight_router_orders
                parlays={best_available_data.parlays}
                onParlaySelect={(p) => alert('Lets go!!!')}
                onSetMarket={(market_id, side_type, side_id) => console.log()}
                onTVSelect={(url) => console.log(url)}
                style={{ margin:3 }}
                flash_markets={flash_markets?.filter(fm => fm.contest_type == 'team' && fm.contest_id == event.event_id)}
                league={leagues.find(l => l.league_id == event.league_id)}
                //hot_markets_direction='vertical'
                onSquaresSelect={() => console.log('')}
                onFlashSelect={(id) => console.log(id)}
                init_expanded={false}
                show_grades
                onViewMarketStats={() => console.log('')}
                show_podcasts={true}
                onShare={(event) => setShareEvent({ visible: true, event_id:event.event_id, title: event.event_title })}
                //onActivate={() => console.log('activate')}
                show_id='true'
                competitions={competitions}
                squares_competitions={squares}
                onTradeLongPress={(trade) => console.log(trade)}
                markets={markets}
                latest_trades={latest_trades}
                best_available_orders={orders}
                event_order_stats={event_order_stats}
                onOrder={(order) => console.log(order)}
                onCompetitionSelect={(competition) => console.log(competition)}
                onView={(data) => console.log(data)}
                onViewAdditionalMarkets={(event_id, eve_type) => console.log(event_id, eve_type)}
            />
            <View style={{}}>
              <Text> HERE THERE IS THIS OVER TAKING IT!?</Text>
            </View>
            {share_event.visible ?
            <View style={{ position:'absolute', flex:1, bottom:75, left:0, right:0, top:0, justifyContent:'flex-end', backgroundColor:Colors.shades.black_faded }}>
              <View style={{ backgroundColor:Colors.shades.white }}>
              <Share
                //generated_link_id='1404'
                allow_edit={true}
                maxHeight={undefined}
                title={share_event.title}
                generator='player'
                player_id={auth_state.player_id}
                onShare={(be_event) => console.log(be_event)}
                link_type='user_generated_link'
                link_sub_type='team_contest_link'
                type_id={share_event.event_id}
                onCancel={() => setShareEvent({ visible:false, title:'' })}
                maxWidth={Dimensions.get('window').width - 20}
                redirect_url={`https://app.bettoredge.com/markets/market/team/${share_event.event_id}/1?refer=jbone`}
                embed={{
                  embed_code: `
                  <div height='300px' id='market' data-teamids='' data-eventids='${share_event.event_id}' />
                  <script src='https://widgets.bettoredge.com/widget.common.js'/>\n
                  <script src='https://widgets.bettoredge.com/widget.market.js'/>
                  `
                  ,
                  widget_element: <div style={{ height: '300px' }} id='market' data-teamids='' data-eventids={share_event.event_id}/>,
                  script_source:'https://widgets.bettoredge.com/widget.market.js',
                  div_id:'market'
                }}
              />
              </View>

            </View>
            :<></>}
          </View>
          :active_component == 'market' ?
          <View style={{ flex:1 }}>
            <MarketApp
              league_ids='3'
              company_id='1'
              referral_code='betspotrac'
            />
          </View>
          :active_component == 'search'?
          <View style={{ flex:1, paddingTop:45 }}>
            <BettorSearch
              init_search_value=' '
              search_style={{ flex:1, padding:5, marginRight:5 }}
              search_types={['players']}
              onSearchResults={(results) => setSearchResults(results)}
            />
            <View>
              <Components.Text>PLAYERS</Components.Text>
              <View style={{ flex:1}}>
                  <SocialComponents.PlayerList
                    players={search_results.players}
                    //style={{ overflow: 'scroll', flexWrap: 'no-wrap', justifyContent: undefined }}
                    options={{
                      follow_status: true,
                      direction: 'horizontal'
                    }}
                    onPlayerSelect={(p) => console.log(p)}
                  />
              </View>
            </View>
          </View>
          : active_component == 'social_profile' ?
          <View style={{ height:844, backgroundColor:Colors.shades.shade100 }}>
            <SocialComponents.PlayerProfile
              viewing_player_id={'98'}
              player_id={auth_state.player_id}
              onBack={() => console.log('GO BACK!!!')}
              height={844}
              onCopyOrder={(order) => console.log(order)}
              onFadeOrder={(order) => {
                console.log('FADED ORDER')
                console.log(order)
              }}
              onStartChat={(id) => console.log(`chat with ${id}`)}
              onHeadToHead={(id) => console.log(`start head to head with ${id}`)}
            />
          </View>
          :active_component == 'manage_embed' && auth_state.me ?
          <View style={{ flex:1, margin:10, paddingTop:Platform.OS == 'web' ? 0 : 40, paddingBottom:Platform.OS == 'web' ? 0 : 40 }}>
            <EmbedManager
              company_embed_id='20'
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomLeftRadius: 8, borderBottomRightRadius:8 }}
              company_id={'1'}
              me={auth_state.me}
            />
          </View>
          :active_component == 'external_price'?
          <View style={{ backgroundColor:Colors.shades.white, flex:1, justifyContent:'flex-end' }}>
            <ExternalPriceComparison 
            price_key={`test`}
            float
              style={{ borderTopLeftRaius:22 }}
              contest_id='93796'
              contest_type='team'
              participant_id='1371'
              participant_type='athlete'
              market_id='5'
            />
          </View>
          :active_component == 'wallet' ?
          <View
                style={{ flex:1, paddingTop:30, paddingBottom:30 }}
                nativeID='auth_widget'
            >
              {!draft_checkout?.visible ?
              <MyWallet
                
                onTransact={(item_order, account_id) => {
                  console.log(item_order)
                  console.log(account_id)
                  setDraftCheckout({item_order, account_id, visible:true})
                  AsyncStorage.setItem('draft_order', JSON.stringify(item_order))
                }}
                onClose={() => {
                  if(draft_checkout){ return setDraftCheckout({ ...draft_checkout, visible:true }) }
                  setActiveComponent('profile')
                }}
              />
              :
              <Checkout
                item_order={draft_checkout.item_order}
                account_id={draft_checkout.account_id}
                onCompleteOrder={(item_order, transaction) => setDraftCheckout(undefined)}
                onCancel={() => setDraftCheckout(undefined)}
                onRequestNewAccount={() => setDraftCheckout({ ...draft_checkout, visible: false })}
              />
            }
            </View>
          : active_component == 'admin_engagements' ?
          <View style={{ flex:1, padding:10 }}>
            <AdminCompetitionList
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius:8, borderBottomLeftRadius:8 }}
              onCreateNew={() => console.log('')}
              onClose={() => console.log('yo!')}
              onSelectBracketCompetition={() => console.log('')}
              onSelectCompetition={() => console.log('')}
              onSelectSquaresCompetition={() => console.log('')}
            />
          </View>
          : active_component == 'poll' ?
          <View style={{ flex:1 }}>
              <PollCampaign
                distinct_id={auth_state.distinct_id}
                onSharePollCampaign={(pc) => console.log(pc)}
                poll_campaign_id='911'
                onBack={() => console.log('Hey!')}
                view_mode='mobile'
                onComplete={() => console.log('DONE!!!')}
                player_id={auth_state.player_id}
                onRequestAuthenticate={() => setActiveComponent('authenticator')}
              />
          </View>
          :active_component == 'set_market' ?
          <View style={{ flex:1, paddingTop:40, paddingBottom:40 }}>
            <MarketComponents.CreateMarketForm
              contest_type={'team'}
              contest_id={'116757'}
              my_orders={auth_state.orders.filter(o => o.event_id == '116757')}
              best_available_orders={orders}
              onCancel={() => console.log('cancelled')}
              onSubmitOrders={() => console.log('create')}
              market_id='2'
            />
          </View>
          :active_component == 'competition' ?
          <View style={{ flex:1, paddingTop:45, paddingBottom:45 }}>
            <CompetitionModule
              view_mode='mobile'
              onRequestAuthentication={() => setActiveComponent('authenticator')}
              player_id={auth_state.player_id}
              onManageCompetition={(c_id) => console.log(c_id)}
              competition_id='16094'
              onClose={() => console.log('hey')}
            />
          </View>
          :active_component == 'squares_manager' ?
          <View style={{ flex:1, padding:10, paddingTop:50, paddingBottom:50 }}>
            <SquaresManager
              float
              player={auth_state.me}
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius:8, borderBottomLeftRadius:8 }}
              sq_comp_id='2014'
            />
          </View>
          :active_component == 'competition_manager' ?
          <View style={{ flex:1, padding:10, paddingTop:50, paddingBottom:50 }}>
            <CompetitionManager
              float
              header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
              footer_style={{ borderBottomRightRadius:8, borderBottomLeftRadius:8 }}
              competition_id='16154'
              onClose={() => console.log('hey')}
              player_id={auth_state.player_id}
            />
          </View>
          :active_component == 'season_manager' ?
          <SeasonManager
            competition_season_id='28'
          />
          :active_component == 'season' ?
          <SeasonModule
            competition_season_id='28'
            player_id={auth_state.player_id}
            onShareSeason={() => console.log('hey')}
            onRequestAuthenticate={() => console.log('AUTH!')}
          />
          :active_component == 'engage' ?
          <View style={{ paddingTop:width < 600 ? 30: undefined }}>
          <EngageModule
            player_id={auth_state.player_id}
            init_engagement='polls'
            onManage={() => console.log('')}
            view_mode={width > 600 ? 'desktop' : 'mobile'}
          />
            </View>
          :
          active_component == 'location' ?
          <View>
            <Button
              style={{ flex:1 }}
              title='Check'
              onPress={() => checkPermissions({ auto_on_granted: true })}
            />
            <LocationTracker
              permission={permission}
              location={location}
              onPromptForPermission={() => getPermissions({ auto_on_granted:true })}
              onGetLocation={() => getLocation({ no_cache: true })}
            />
          </View>
          :active_component == 'charts' ?
          <ScrollView style={{ flex: 1, paddingTop: Platform.OS === 'web' ? 20 : 60 }}>

            <View style={{ paddingHorizontal: 20, marginTop: 40 }}>
              <Text theme='h2' size={18} style={{ marginBottom: 10 }}>Smoothed Data</Text>
              <Text theme='description' size={12} style={{ marginBottom: 15 }}>
                Smart sampling with moving average smoothing for cleaner lines
              </Text>
            </View>

            <View float style={{ margin:10, padding:20 }}>
              <LivePriceChart
                data={TradeChartAdapter.toTimeSeriesData(trades_chart, {
                  gradient: true,
                  curved: true,
                  showDataPoints: true,
                  smartSampling: true,
                  smoothing: true,
                  maxPoints: 100,
                  sideLabels: [
                    { side: 'home', label: 'Lakers' },
                    { side: 'away', label: 'Celtics' }
                  ]
                })}
                showTimeFilter
                displayAsPercentage
                yMin={0}
                hideDataPointText
                yMax={1}
                useFixedYRange={true}
                showYAxis={false}
                showXAxis={false}
                showGrid={false}
                animated={true}
                showTooltip={true}
                showLegend={true}
                legendPosition="inline"
              />
            </View>

            <View style={{ paddingHorizontal: 20 }}>
              <Text theme='description' size={14} style={{ marginTop: 20, marginBottom: 40 }}>
                Charts automatically adjust sampling rate based on data timespan:{'\n'}
                • {'<'} 1 hour: sample every minute{'\n'}
                • {'<'} 1 day: sample every 5 minutes{'\n'}
                • {'<'} 1 week: sample every 30 minutes{'\n'}
                • {'<'} 1 month: sample every 3 hours{'\n'}
                • {'>'} 1 month: sample every 12 hours
              </Text>
            </View>
          </ScrollView>
          :<></>}
        </View>
      )}
    </View>
  )


}

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  modalContainer: { flex:1 },
  viewContainer: { flex:1, justifyContent:'flex-end' },
  desktopContainer:{ flex:1, justifyContent:'center', alignItems:'center' },
  box: {
    width: 60,
    height: 60,
    marginVertical: 20,
  },
  authContainer: { borderTopRightRadius:40, borderTopLeftRadius:40, backgroundColor:Colors.shades.white }
});



